import { render, staticRenderFns } from "./financeiro.vue?vue&type=template&id=dc436fe6&scoped=true"
import script from "./financeiro.vue?vue&type=script&lang=ts"
export * from "./financeiro.vue?vue&type=script&lang=ts"
import style0 from "./financeiro.vue?vue&type=style&index=0&id=dc436fe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc436fe6",
  null
  
)

export default component.exports